import cn from 'classnames';

import { VerticalBar } from '@features/components/ClinicalBarChart/VerticalBar';

type BloodGasRecordData = {
  timestamp: string;
  time: string;
  pfRatio: number;
  ocsTime: string;
  paO2: number;
  pvO2: number;
  isOnOcs: boolean;
};

type BloodGasesRecordProps = {
  isSelected: boolean;
  onClick: () => void;
  record: BloodGasRecordData;
  maxValue: number;
};

const paO2BgColor = (selected: boolean) => (selected ? 'bg-maroon-20' : 'bg-maroon-30');
const pvO2BgColor = (selected: boolean) => (selected ? 'bg-blue-saturated' : 'bg-blue-50');
const paO2TextColor = (selected: boolean) => (selected ? 'text-maroon-20' : 'text-maroon-30');
const pvO2TextColor = (selected: boolean) => (selected ? 'text-blue-saturated' : 'text-blue-50');

export const BloodGasRecord = ({ isSelected, onClick, record, maxValue }: BloodGasesRecordProps) => {
  const { ocsTime, time, paO2, pvO2, pfRatio, isOnOcs } = record;

  return (
    <div
      aria-label="Blood Gas Record"
      className="flex flex-col items-center pb-1 w-40"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={onClick}
    >
      <div className="flex w-full items-end leading-none font-semibold">
        <div className="flex flex-1 w-full flex-col gap-1 items-center">
          <div className={cn(pvO2TextColor(isSelected), 'text-sm')}>{pvO2}</div>
          <VerticalBar
            containerClassName="w-full"
            maxBarSize={65}
            color={pvO2BgColor(isSelected)}
            max={maxValue}
            value={pvO2}
          />
        </div>

        <div className="flex flex-1 w-full flex-col gap-1 items-center">
          <div className={cn(paO2TextColor(isSelected), 'text-sm')}>{paO2}</div>
          <VerticalBar
            maxBarSize={65}
            containerClassName="w-full"
            color={paO2BgColor(isSelected)}
            max={maxValue}
            value={paO2}
          />
        </div>
      </div>
      <div className="font-semibold text-sm text-base-5">{pfRatio}</div>
      <div className="text-xs">{isOnOcs ? ocsTime : time}</div>
    </div>
  );
};
